import { Link } from "react-router-dom";
import { Instagram, Facebook, Linkedin, Youtube, Mail, Phone, MapPin, MessageCircle } from "lucide-react";
import { CONTACT } from "../data/content";

const cols = [
  {
    title: "Company",
    links: [
      { label: "About Us", to: "/about" },
      { label: "Industries", to: "/industries" },
      { label: "ERP Solutions", to: "/erp" },
      { label: "Insights (Blog)", to: "/blog" },
      { label: "Contact", to: "/contact" },
    ],
  },
  {
    title: "Services",
    links: [
      { label: "Social Media Marketing", to: "/services#social-media-marketing" },
      { label: "SEO", to: "/services#seo" },
      { label: "Google Ads", to: "/services#google-ads" },
      { label: "Website Development", to: "/services#website-development" },
      { label: "Branding & Design", to: "/services#branding" },
      { label: "ERP Solutions", to: "/erp" },
    ],
  },
  {
    title: "Solutions",
    links: [
      { label: "Digital Marketing", to: "/services" },
      { label: "Business Automation", to: "/erp" },
      { label: "School ERP", to: "/erp" },
      { label: "E-commerce", to: "/services#ecommerce" },
    ],
  },
];

const socials = [
  { icon: Instagram, href: "https://instagram.com", label: "Instagram" },
  { icon: Facebook, href: "https://facebook.com", label: "Facebook" },
  { icon: Linkedin, href: "https://linkedin.com", label: "LinkedIn" },
  { icon: Youtube, href: "https://youtube.com", label: "YouTube" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-cyan-500/10 bg-[#051224] noise">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 pt-16 pb-8">
      <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1fr_1.2fr]">
        <div>
          <span className="inline-flex items-center rounded-xl bg-white px-3.5 py-2 shadow-lg shadow-black/25">
            <img src="/logo.png" alt="DG Hubs — Grow Your Business" className="h-10 w-auto" />
          </span>
          <p className="mt-4 font-display text-lg font-semibold text-grad">Everything Digital. One Powerful Hub.</p>
          <p className="mt-3 max-w-xs text-sm leading-relaxed text-slate-400">
            From building your brand to marketing it, from creating your website to automating your business — your complete digital ecosystem under one roof.
          </p>
          <div className="mt-6 flex gap-3">
            {socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                data-testid={`footer-social-${s.label.toLowerCase()}`}
                className="grid h-9 w-9 place-items-center rounded-lg border border-white/10 text-slate-400 transition-all duration-300 hover:border-dg-cyan hover:text-dg-cyan hover:-translate-y-0.5"
              >
                <s.icon size={16} />
              </a>
            ))}
          </div>
        </div>

        {cols.map((c) => (
          <div key={c.title}>
            <h4 className="font-mono text-[11px] uppercase tracking-[0.25em] text-dg-cyan">{c.title}</h4>
            <ul className="mt-5 space-y-3">
              {c.links.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-sm text-slate-400 transition-colors duration-300 hover:text-white">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div>
          <h4 className="font-mono text-[11px] uppercase tracking-[0.25em] text-dg-cyan">Contact</h4>
          <ul className="mt-5 space-y-4 text-sm text-slate-400">
            <li className="flex items-start gap-3"><MapPin size={16} className="mt-0.5 shrink-0 text-dg-cyan" />{CONTACT.location}</li>
            <li>
              <a href={CONTACT.emailHref} data-testid="footer-email" className="flex items-center gap-3 hover:text-white transition-colors">
                <Mail size={16} className="shrink-0 text-dg-cyan" />{CONTACT.email}
              </a>
            </li>
            <li>
              <a href={CONTACT.phoneHref} data-testid="footer-phone" className="flex items-center gap-3 hover:text-white transition-colors">
                <Phone size={16} className="shrink-0 text-dg-cyan" />{CONTACT.phone}
              </a>
            </li>
            <li>
              <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-3 hover:text-white transition-colors">
                <MessageCircle size={16} className="shrink-0 text-dg-cyan" />WhatsApp Us
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/5 pt-7 sm:flex-row">
        <p className="text-xs text-slate-500">© 2026 DG Hubs. All Rights Reserved.</p>
        <div className="flex gap-6 text-xs text-slate-500">
          <span className="cursor-pointer hover:text-slate-300 transition-colors">Privacy Policy</span>
          <span className="cursor-pointer hover:text-slate-300 transition-colors">Terms & Conditions</span>
          <span className="cursor-pointer hover:text-slate-300 transition-colors">Cookie Policy</span>
        </div>
      </div>
    </div>
  </footer>
);
